import { includes, some } from "lodash"

export const STEPS = [{
  id: "instrument",
  label: "Choose your reference instrument",
  cancelButton: "Cancel",
  submitButton: "Next",
}, {
  id: "topic",
  label: "Create Research Topic for ...",
  cancelButton: "Cancel",
  submitButton: "Create research topic",
}]

export function instrumentPortfolioQuery(instrument) {
  const { id } = instrument
  return {
    query: `query($id:String!){
      portfolio: portfolio(id: $id) {
        name
        description
        availableFrom
        rolloverPositionSetToCurrentDate
      }
    }`,
    variables: {
      id,
    },
  }
}
export function instrumentSecurityQuery(modelId, item) {
  const { ticker, exchange: mic, internalId } = item || {}
  return {
    query: `query($modelId: String!, $internalId: String!){
      model(id: $modelId) {
        security(internalId:$internalId) {
          availability {
            from
            to
          }
        }
      }
    }`,
    variables: {
      modelId,
      internalId,
      ticker,
      mic,
    },
  }
}

// UnifiedSearch when choosing a reference instrument for a research topic
export const disableSearchResult = (item) => some([
  (item) => item.type === "security" && item.assetClass === "swap",
  (item) => !includes(["security", "portfolio"], item.type),
], (fn) => fn(item))
